"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9590],{

/***/ 99590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77058);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_molecules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53732);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _DAO__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90793);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60651);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9465);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var MapView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 261).then(__webpack_require__.bind(__webpack_require__, 20261));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(20261)];
    }
  }
}); // const PopularityCardView = dynamic(() => import("./PopularityCardView"), {
//   ssr: false,
// });

var LineupCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 2480).then(__webpack_require__.bind(__webpack_require__, 12480));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(12480)];
    }
  }
});
var WallCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 7193).then(__webpack_require__.bind(__webpack_require__, 27193));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(27193)];
    }
  }
});
var VenueCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 6207).then(__webpack_require__.bind(__webpack_require__, 36207));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36207)];
    }
  }
});
var EventCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 5578).then(__webpack_require__.bind(__webpack_require__, 5578));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(5578)];
    }
  }
});
var MemoryCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 8331).then(__webpack_require__.bind(__webpack_require__, 78331));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78331)];
    }
  }
});
var MediaCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 4250).then(__webpack_require__.bind(__webpack_require__, 94250));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94250)];
    }
  }
});
var EditionCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 8057).then(__webpack_require__.bind(__webpack_require__, 98057));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98057)];
    }
  }
});
var SubListCardView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 1345).then(__webpack_require__.bind(__webpack_require__, 41345));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41345)];
    }
  }
});
var BottomInfoView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 3939).then(__webpack_require__.bind(__webpack_require__, 33939));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33939)];
    }
  }
});
var NearByFestivalView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 1766).then(__webpack_require__.bind(__webpack_require__, 41766));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41766)];
    }
  }
});
var NearByOtherHomeView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 4461).then(__webpack_require__.bind(__webpack_require__, 34461));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(34461)];
    }
  }
});
var NearByVenueView = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 4281).then(__webpack_require__.bind(__webpack_require__, 34281));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(34281)];
    }
  }
});
var GuideProfile = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 7333).then(__webpack_require__.bind(__webpack_require__, 27333));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(27333)];
    }
  }
});
var SpotifyListContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(function () {
  return __webpack_require__.e(/* import() */ 8561).then(__webpack_require__.bind(__webpack_require__, 88561));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(88561)];
    }
  }
});

var ProfileAbout = function ProfileAbout(props) {
  var _props$item3, _props$item3$lineup, _props$item4, _props$item8, _props$item9, _props$item10, _props$item11, _props$item12;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      selectedTabIndex = _useState[0],
      setSelectedTabIndex = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      tagCategories = _useState2[0],
      setTagCategories = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showTagCategoryModal = _useState3[0],
      setShowTagCategoryModal = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      detailTagCategory = _useState4[0],
      setDetailCategory = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      editionTotal = _useState5[0],
      setEditionTotal = _useState5[1];

  var navigation = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  var _props$item = props.item,
      description = _props$item.description,
      tags = _props$item.tags,
      accomodationUrl = _props$item.accomodationUrl,
      transportUrl = _props$item.transportUrl,
      spotifyId = _props$item.spotifyId,
      mapLink = _props$item.mapLink,
      status = _props$item.status,
      capacity = _props$item.capacity,
      roomCount = _props$item.roomCount,
      contact = _props$item.contact,
      contactWebsite_follow_link = _props$item.contactWebsite_follow_link,
      isOfficial = _props$item.isOfficial,
      isPro = _props$item.isPro,
      amenities = _props$item.amenities;
  var _props$item2 = props.item,
      location = _props$item2.location,
      longitude = _props$item2.longitude,
      latitude = _props$item2.latitude,
      city = _props$item2.city,
      venue = _props$item2.venue,
      address = _props$item2.address,
      postcode = _props$item2.postcode,
      nationality = _props$item2.nationality;
  var lineupPoster = props === null || props === void 0 ? void 0 : (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : (_props$item3$lineup = _props$item3.lineup) === null || _props$item3$lineup === void 0 ? void 0 : _props$item3$lineup.lineupPoster;

  var getAddress = function getAddress(address, venue, city, country) {
    var addressList = [];

    if (address && address != undefined) {
      addressList.push(address);
    }

    if (venue && venue != undefined) {
      addressList.push(venue);
    }

    if (city && city != undefined) {
      addressList.push(city);
    }

    if (country && country != undefined) {
      addressList.push(country);
    }

    return addressList.join(", ");
  };

  var _address = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return getAddress(address, venue, city, nationality);
  }, [city, venue, address, nationality]);

  var _location = {
    longitude: longitude || 51.501246,
    latitude: latitude || -0.127161
  };
  var category = props.category;
  var isShowLineupCard = category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT;
  var isShowWall = false;
  var isShowMemories = false;
  var isTBC = status === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED */ .gT.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED;
  var isReschedule = status === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED */ .gT.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED;
  var isShowMapView = (category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) && !isTBC && !isReschedule;
  var isShowSpotifyPlayer = category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST && spotifyId;
  var isArtist = category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST;
  var isShowNearByFestival = category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT;
  var isShowNearByVenue = category != _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL && category != _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT && category != _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST && category != _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && category != _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL;

  var constructMenuItems = function constructMenuItems(tagGroups) {
    // if (process.env.NEXT_PUBLIC_APP_NAME !== "Festicket") {
    return [{
      title: "Features",
      count: 0,
      withoutCount: true
    }]; // } else {
    //   if (!tagGroups) return [];
    //   return tagGroups.map((tagGroup) => {
    //     return {
    //       title: tagGroup.title,
    //       count:
    //         tagGroup.children.filter(
    //           (i) =>
    //             i.category !== Constants.tagCategory.TAG_CATEGORY_FLOOR &&
    //             i.category !== Constants.tagCategory.TAG_CATEGORY_VIEW &&
    //             category == Constants.categoryType.CATEGORY_ROOFTOP &&
    //             i.category !== Constants.tagCategory.TAG_CATEGORY_ACCESS
    //         ).length +
    //         (tagGroup.title === "Venue"
    //           ? category === Constants.categoryType.CATEGORY_SPA
    //             ? 2
    //             : 1
    //           : 0), //Add website icon tag for Venue
    //     };
    //   });
    // }
  };

  var isShowVenues = props.item.venues != undefined;

  var loadEdition = function loadEdition() {
    var parameters = {
      editionEventId: props.item.id,
      sortType: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.sortByAction.SORT_BY_LATE */ .gT.sortByAction.SORT_BY_LATE
    };
    _DAO__WEBPACK_IMPORTED_MODULE_10__/* .EventDao.findWeb */ .SA.findWeb(parameters).then(function (result) {
      setEditionTotal(result.data.length);
    })["catch"](function (err) {
      console.error("error", err);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    _onSelectTab(0);

    if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL) {
      loadEdition();
    }
  }, [JSON.stringify(props.item)]);
  var menuItems = constructMenuItems(tags);

  var _onSelectTab = function onSelectTab(currentIndex) {
    // if (process.env.NEXT_PUBLIC_APP_NAME !== "Festicket") {
    if (tags && tags.length > 0) {
      var result = [];
      tags.forEach(function (item, index) {
        var _tagGroup$children;

        var tagGroup = tags[index];

        var _tagCategories = (tagGroup === null || tagGroup === void 0 ? void 0 : (_tagGroup$children = tagGroup.children) === null || _tagGroup$children === void 0 ? void 0 : _tagGroup$children.filter(function (i) {
          return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR && i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW;
        })) || [];

        result = result.concat(_tagCategories);
      });
      setTagCategories(result);
    } // } else {
    //   setSelectedTabIndex(currentIndex);
    //   if (tags && tags.length > currentIndex) {
    //     const tagGroup = tags[currentIndex];
    //     const _tagCategories =
    //       tagGroup.children.filter(
    //         (i) =>
    //           i.category !== Constants.tagCategory.TAG_CATEGORY_FLOOR &&
    //           i.category !== Constants.tagCategory.TAG_CATEGORY_VIEW
    //       ) || [];
    //     setTagCategories(_tagCategories);
    //   }
    // }

  };

  var onPressTagItem = function onPressTagItem(item) {
    if (item && item.children && !item.withoutClick) {
      setDetailCategory(item);
      setShowTagCategoryModal(true);
    }
  };

  var navigateToProfileBottomScreen = function navigateToProfileBottomScreen(bottomMenuType) {
    if (props.changeTabType) {
      props.changeTabType(bottomMenuType);
    }
  };

  var getDeclaimText = function getDeclaimText(profileCategory) {
    if (profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT) {
      return t("key_declaim_festival");
    } else if (profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST) {
      return t("key_declaim_artist");
    } else if (profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || profileCategory == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
      return t("key_declaim_venue");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES) {
      return t("key_declaim_prefab");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL) {
      return t("key_declaim_zoopedia");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL) {
      return t("key_declaim_parkful");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO) {
      return t("key_declaim_casino");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE) {
      return t("key_declaim_castle");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT) {
      return t("key_declaim_resort");
    } else if (profileCategory === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) {
      return t("key_declaim_aparthotel");
    }
  };

  var getLinkTags = function getLinkTags() {
    var _socialPrefix;

    var item = props.item;
    var socialPrefix = (_socialPrefix = {}, (0,_home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_socialPrefix, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_INSTAGRAM */ .gT.socialType.SOCIAL_TYPE_INSTAGRAM, "https://instagram.com/"), (0,_home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_socialPrefix, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_FACEBOOK */ .gT.socialType.SOCIAL_TYPE_FACEBOOK, "https://facebook.com/"), (0,_home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_socialPrefix, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_TIKTOK */ .gT.socialType.SOCIAL_TYPE_TIKTOK, "https://tiktok.com/@"), (0,_home_runner_work_webApp_webApp_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_socialPrefix, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_YOUTUBE */ .gT.socialType.SOCIAL_TYPE_YOUTUBE, "https://youtube.com/"), _socialPrefix);

    var getSocialUrl = function getSocialUrl(socialType) {
      var _item$socialIds, _item$socialIds$find;

      var username = item === null || item === void 0 ? void 0 : (_item$socialIds = item.socialIds) === null || _item$socialIds === void 0 ? void 0 : (_item$socialIds$find = _item$socialIds.find(function (i) {
        return i.socialType === socialType;
      })) === null || _item$socialIds$find === void 0 ? void 0 : _item$socialIds$find.username;
      return username ? socialPrefix[socialType] + username : null;
    };

    var toAbsoluteUrl = function toAbsoluteUrl(url) {
      return url && !url.includes("http") ? "https://".concat(url) : url;
    };

    var links = [{
      name: "Website",
      url: contact === null || contact === void 0 ? void 0 : contact.website
    }, {
      name: "Instagram",
      url: (contact === null || contact === void 0 ? void 0 : contact.instagramUrl) || (item === null || item === void 0 ? void 0 : item.socialInstagram) || getSocialUrl(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_INSTAGRAM */ .gT.socialType.SOCIAL_TYPE_INSTAGRAM)
    }, {
      name: "Facebook",
      url: (contact === null || contact === void 0 ? void 0 : contact.facebookUrl) || (item === null || item === void 0 ? void 0 : item.socialFacebook) || getSocialUrl(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_FACEBOOK */ .gT.socialType.SOCIAL_TYPE_FACEBOOK)
    }, {
      name: "TikTok",
      url: (contact === null || contact === void 0 ? void 0 : contact.tiktokUrl) || (item === null || item === void 0 ? void 0 : item.socialTiktok) || getSocialUrl(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_TIKTOK */ .gT.socialType.SOCIAL_TYPE_TIKTOK)
    }, {
      name: "YouTube",
      url: (contact === null || contact === void 0 ? void 0 : contact.youtubeUrl) || (item === null || item === void 0 ? void 0 : item.socialYoutube) || getSocialUrl(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.socialType.SOCIAL_TYPE_YOUTUBE */ .gT.socialType.SOCIAL_TYPE_YOUTUBE)
    }];
    return links.filter(function (link) {
      return link.url;
    }).map(function (link) {
      return {
        name: link.name,
        title: link.name,
        linkUrl: toAbsoluteUrl(link.url),
        order: 99
      };
    });
  };

  var getTagCategories = function getTagCategories() {
    var _newTagCategories$fil;

    var newTagCategories = tagCategories.filter(function (i) {
      return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR && i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW;
    }).map(function (i) {
      if ((i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE */ .gT.tagCategory.TAG_CATEGORY_SIZE || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE */ .gT.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE) && (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL)) {
        // if (i.children.length > 0) {
        //   let children = [
        //     ...i.children,
        //     capacity
        //       ? {
        //           id: i.children[0] + 1,
        //           pid: 500,
        //           level: 2,
        //           type: 0,
        //           title: `Capacity - ${capacity}`,
        //           description: null,
        //           icon: "",
        //           order: 0,
        //           category: 0,
        //           filter_slug: `Capacity - ${capacity}`,
        //           createdAt: null,
        //           updatedAt: null,
        //           name: `Capacity - ${capacity}`,
        //           leafCount: 1,
        //           isLeaf: true,
        //           minValue: null,
        //           maxValue: null,
        //           unit: null,
        //         }
        //       : null,
        //     roomCount
        //       ? {
        //           id: i.children[0] + 2,
        //           pid: 500,
        //           level: 2,
        //           type: 0,
        //           title: `Rooms - ${roomCount}`,
        //           description: null,
        //           icon: "",
        //           order: 0,
        //           category: 0,
        //           filter_slug: `Rooms - ${roomCount}`,
        //           createdAt: null,
        //           updatedAt: null,
        //           name: `Rooms - ${roomCount}`,
        //           leafCount: 1,
        //           isLeaf: true,
        //           minValue: null,
        //           maxValue: null,
        //           unit: null,
        //         }
        //       : null,
        //   ];
        //   return { ...i, children: children.filter((i) => i) };
        // } else {
        return i; // }
      } else if ((category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) && (i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE_2 */ .gT.tagCategory.TAG_CATEGORY_VENUE_2)) {
        return _objectSpread(_objectSpread({}, i), {}, {
          icon: "Local:iconTagGeneral"
        });
      } else {
        return i;
      }
    });

    if ((amenities === null || amenities === void 0 ? void 0 : amenities.length) > 0 && (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE)) {
      newTagCategories.push({
        id: -1,
        pid: 1,
        level: 1,
        type: 0,
        title: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Features" : "Amenities",
        description: null,
        icon: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Local:iconTagFeature" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Local:iconTagAmenities" : "Local:iconTagStatus",
        order: 0,
        category: 9,
        filter_slug: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Features" : "Amenities",
        createdAt: null,
        updatedAt: null,
        name: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Features" : "Amenities",
        children: amenities.map(function (item) {
          return {
            id: 1,
            pid: 500,
            level: 2,
            type: 0,
            title: item.name,
            description: null,
            icon: "",
            order: 0,
            category: 0,
            filter_slug: item.name,
            createdAt: null,
            updatedAt: null,
            name: item.name,
            leafCount: 1,
            isLeaf: true,
            minValue: null,
            maxValue: null,
            unit: null
          };
        }),
        leafCount: 0
      });
    }

    if ( // selectedTabIndex === 0 &&
    (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) && ( false || "Cocktayl" == "Beachful")) { var _newTagCategories; } else if ((category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) && contact !== null && contact !== void 0 && contact.website) {
      var _contact$website;

      newTagCategories.push({
        id: -1,
        pid: 1,
        level: 1,
        type: 0,
        title: "Website",
        description: null,
        icon: contactWebsite_follow_link ? "Local:iconWebsiteColored" : "Local:iconWebsiteGray",
        order: 99,
        category: 9,
        filter_slug: "Website",
        createdAt: null,
        updatedAt: null,
        name: "Website",
        value: !(contact !== null && contact !== void 0 && (_contact$website = contact.website) !== null && _contact$website !== void 0 && _contact$website.includes("http")) ? "https://".concat(contact === null || contact === void 0 ? void 0 : contact.website) : contact === null || contact === void 0 ? void 0 : contact.website,
        contactWebsite_follow_link: contactWebsite_follow_link,
        children: [],
        leafCount: 0
      });
    }

    if (((_newTagCategories$fil = newTagCategories.filter(function (i) {
      return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
    })) === null || _newTagCategories$fil === void 0 ? void 0 : _newTagCategories$fil.length) > 0) {
      var _newTagCategories$fin, _newTagCategories$fin2, _newTagCategories$fin3, _newTagCategories$fin4, _newTagCategories$fin5, _newTagCategories$fin6, _newTagCategories$fin7, _newTagCategories$fin8, _newTagCategories$fin9;

      var newTagCategoriesWithoutAge = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
      });
      newTagCategoriesWithoutAge.push(_objectSpread(_objectSpread({}, newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
      })), {}, {
        children: [_objectSpread(_objectSpread({}, (_newTagCategories$fin = newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
        })) === null || _newTagCategories$fin === void 0 ? void 0 : _newTagCategories$fin.children[0]), {}, {
          name: "+".concat((_newTagCategories$fin2 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
          })) === null || _newTagCategories$fin2 === void 0 ? void 0 : (_newTagCategories$fin3 = _newTagCategories$fin2.children[0]) === null || _newTagCategories$fin3 === void 0 ? void 0 : (_newTagCategories$fin4 = _newTagCategories$fin3.minValue) === null || _newTagCategories$fin4 === void 0 ? void 0 : (_newTagCategories$fin5 = _newTagCategories$fin4.toString()) === null || _newTagCategories$fin5 === void 0 ? void 0 : _newTagCategories$fin5.split(".")[0]),
          title: "+".concat((_newTagCategories$fin6 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
          })) === null || _newTagCategories$fin6 === void 0 ? void 0 : (_newTagCategories$fin7 = _newTagCategories$fin6.children[0]) === null || _newTagCategories$fin7 === void 0 ? void 0 : (_newTagCategories$fin8 = _newTagCategories$fin7.minValue) === null || _newTagCategories$fin8 === void 0 ? void 0 : (_newTagCategories$fin9 = _newTagCategories$fin8.toString()) === null || _newTagCategories$fin9 === void 0 ? void 0 : _newTagCategories$fin9.split(".")[0])
        })]
      }));
      newTagCategories = newTagCategoriesWithoutAge;
    }

    if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP) {
      return newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ACCESS */ .gT.tagCategory.TAG_CATEGORY_ACCESS;
      });
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA) {
      var _newTagCategories$fin10, _newTagCategories$fin11;

      var result = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE_2 */ .gT.tagCategory.TAG_CATEGORY_VENUE_2;
      });

      if (((_newTagCategories$fin10 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE;
      })) === null || _newTagCategories$fin10 === void 0 ? void 0 : (_newTagCategories$fin11 = _newTagCategories$fin10.children) === null || _newTagCategories$fin11 === void 0 ? void 0 : _newTagCategories$fin11.length) > 0) {
        var _newTagCategories$fin12, _newTagCategories$fin13, _newTagCategories$fin14;

        result.push(_objectSpread(_objectSpread({}, newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE;
        })), {}, {
          children: (_newTagCategories$fin12 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE;
          })) === null || _newTagCategories$fin12 === void 0 ? void 0 : (_newTagCategories$fin13 = _newTagCategories$fin12.children) === null || _newTagCategories$fin13 === void 0 ? void 0 : _newTagCategories$fin13.concat((_newTagCategories$fin14 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE_2 */ .gT.tagCategory.TAG_CATEGORY_VENUE_2;
          })) === null || _newTagCategories$fin14 === void 0 ? void 0 : _newTagCategories$fin14.children)
        }));
      }

      return result;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES) {
      var _newTagCategories$fin15, _newTagCategories$fin16, _newTagCategories$fil2, _newTagCategories$fin23, _newTagCategories$fin24, _newTagCategories$fin27, _newTagCategories$fin28, _newTagCategories$fin31, _newTagCategories$fin32, _newTagCategories$fin37, _newTagCategories$fin38, _newTagCategories$fin43, _newTagCategories$fin44, _newTagCategories$fin49, _newTagCategories$fin50, _newTagCategories$fin55, _newTagCategories$fin56, _newTagCategories$fin61, _newTagCategories$fin62, _newTagCategories$fin65, _newTagCategories$fin66, _newTagCategories$fin69, _newTagCategories$fin70;

      var _result = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_VARIANT */ .gT.tagCategory.TAG_CATEGORY_PREFAB_VARIANT;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_MODULE */ .gT.tagCategory.TAG_CATEGORY_PREFAB_MODULE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_STORIES */ .gT.tagCategory.TAG_CATEGORY_PREFAB_STORIES;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
      });

      _result.push({
        id: -1,
        pid: 1,
        level: 1,
        type: 0,
        description: null,
        icon: "Local:iconTagGeneral",
        order: 66,
        category: 9,
        createdAt: null,
        updatedAt: null,
        children: [],
        leafCount: 0,
        withoutClick: true,
        title: null
      });

      if (((_newTagCategories$fin15 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
      })) === null || _newTagCategories$fin15 === void 0 ? void 0 : (_newTagCategories$fin16 = _newTagCategories$fin15.children) === null || _newTagCategories$fin16 === void 0 ? void 0 : _newTagCategories$fin16.length) > 0) {
        var children = [];
        newTagCategories.filter(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
        }).map(function (item) {
          children.push(item.children[0]);
        });

        _result.push(_objectSpread(_objectSpread({}, newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
        })), {}, {
          children: (0,lodash__WEBPACK_IMPORTED_MODULE_8__.uniqBy)(children, "id")
        }));
      }

      if (((_newTagCategories$fil2 = newTagCategories.filter(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH;
      })) === null || _newTagCategories$fil2 === void 0 ? void 0 : _newTagCategories$fil2.length) > 0) {
        var _newTagCategories$fin17, _newTagCategories$fin18, _newTagCategories$fin19, _newTagCategories$fin20, _newTagCategories$fin21, _newTagCategories$fin22;

        _result.push({
          title: "Dimension | ".concat((_newTagCategories$fin17 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH;
          })) !== null && _newTagCategories$fin17 !== void 0 && (_newTagCategories$fin18 = _newTagCategories$fin17.children[0]) !== null && _newTagCategories$fin18 !== void 0 && _newTagCategories$fin18.label ? ((_newTagCategories$fin19 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_WIDTH;
          })) === null || _newTagCategories$fin19 === void 0 ? void 0 : (_newTagCategories$fin20 = _newTagCategories$fin19.children[0]) === null || _newTagCategories$fin20 === void 0 ? void 0 : _newTagCategories$fin20.label) + " X " : "").concat((_newTagCategories$fin21 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH */ .gT.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_LENGTH;
          })) === null || _newTagCategories$fin21 === void 0 ? void 0 : (_newTagCategories$fin22 = _newTagCategories$fin21.children[0]) === null || _newTagCategories$fin22 === void 0 ? void 0 : _newTagCategories$fin22.label, " ft"),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin23 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM;
      })) === null || _newTagCategories$fin23 === void 0 ? void 0 : (_newTagCategories$fin24 = _newTagCategories$fin23.children) === null || _newTagCategories$fin24 === void 0 ? void 0 : _newTagCategories$fin24.length) > 0) {
        var _newTagCategories$fin25, _newTagCategories$fin26;

        _result.push({
          title: "Other rooms | ".concat((_newTagCategories$fin25 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM;
          })) === null || _newTagCategories$fin25 === void 0 ? void 0 : (_newTagCategories$fin26 = _newTagCategories$fin25.children[0]) === null || _newTagCategories$fin26 === void 0 ? void 0 : _newTagCategories$fin26.name),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin27 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM;
      })) === null || _newTagCategories$fin27 === void 0 ? void 0 : (_newTagCategories$fin28 = _newTagCategories$fin27.children) === null || _newTagCategories$fin28 === void 0 ? void 0 : _newTagCategories$fin28.length) > 0) {
        var _newTagCategories$fin29, _newTagCategories$fin30;

        _result.push({
          title: "Bedrooms | ".concat((_newTagCategories$fin29 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM;
          })) === null || _newTagCategories$fin29 === void 0 ? void 0 : (_newTagCategories$fin30 = _newTagCategories$fin29.children[0]) === null || _newTagCategories$fin30 === void 0 ? void 0 : _newTagCategories$fin30.name),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin31 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM;
      })) === null || _newTagCategories$fin31 === void 0 ? void 0 : (_newTagCategories$fin32 = _newTagCategories$fin31.children) === null || _newTagCategories$fin32 === void 0 ? void 0 : _newTagCategories$fin32.length) > 0) {
        var _newTagCategories$fin33, _newTagCategories$fin34, _newTagCategories$fin35, _newTagCategories$fin36;

        _result.push({
          title: "Bathrooms | ".concat((_newTagCategories$fin33 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM */ .gT.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM;
          })) === null || _newTagCategories$fin33 === void 0 ? void 0 : (_newTagCategories$fin34 = _newTagCategories$fin33.children[0]) === null || _newTagCategories$fin34 === void 0 ? void 0 : (_newTagCategories$fin35 = _newTagCategories$fin34.minValue) === null || _newTagCategories$fin35 === void 0 ? void 0 : (_newTagCategories$fin36 = _newTagCategories$fin35.toString()) === null || _newTagCategories$fin36 === void 0 ? void 0 : _newTagCategories$fin36.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin37 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_VARIANT */ .gT.tagCategory.TAG_CATEGORY_PREFAB_VARIANT;
      })) === null || _newTagCategories$fin37 === void 0 ? void 0 : (_newTagCategories$fin38 = _newTagCategories$fin37.children) === null || _newTagCategories$fin38 === void 0 ? void 0 : _newTagCategories$fin38.length) > 0) {
        var _newTagCategories$fin39, _newTagCategories$fin40, _newTagCategories$fin41, _newTagCategories$fin42;

        _result.push({
          title: "Variants | ".concat((_newTagCategories$fin39 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_VARIANT */ .gT.tagCategory.TAG_CATEGORY_PREFAB_VARIANT;
          })) === null || _newTagCategories$fin39 === void 0 ? void 0 : (_newTagCategories$fin40 = _newTagCategories$fin39.children[0]) === null || _newTagCategories$fin40 === void 0 ? void 0 : (_newTagCategories$fin41 = _newTagCategories$fin40.minValue) === null || _newTagCategories$fin41 === void 0 ? void 0 : (_newTagCategories$fin42 = _newTagCategories$fin41.toString()) === null || _newTagCategories$fin42 === void 0 ? void 0 : _newTagCategories$fin42.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin43 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY;
      })) === null || _newTagCategories$fin43 === void 0 ? void 0 : (_newTagCategories$fin44 = _newTagCategories$fin43.children) === null || _newTagCategories$fin44 === void 0 ? void 0 : _newTagCategories$fin44.length) > 0) {
        var _newTagCategories$fin45, _newTagCategories$fin46, _newTagCategories$fin47, _newTagCategories$fin48;

        _result.push({
          title: "Capacity | ".concat((_newTagCategories$fin45 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY;
          })) === null || _newTagCategories$fin45 === void 0 ? void 0 : (_newTagCategories$fin46 = _newTagCategories$fin45.children[0]) === null || _newTagCategories$fin46 === void 0 ? void 0 : (_newTagCategories$fin47 = _newTagCategories$fin46.minValue) === null || _newTagCategories$fin47 === void 0 ? void 0 : (_newTagCategories$fin48 = _newTagCategories$fin47.toString()) === null || _newTagCategories$fin48 === void 0 ? void 0 : _newTagCategories$fin48.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin49 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_STORIES */ .gT.tagCategory.TAG_CATEGORY_PREFAB_STORIES;
      })) === null || _newTagCategories$fin49 === void 0 ? void 0 : (_newTagCategories$fin50 = _newTagCategories$fin49.children) === null || _newTagCategories$fin50 === void 0 ? void 0 : _newTagCategories$fin50.length) > 0) {
        var _newTagCategories$fin51, _newTagCategories$fin52, _newTagCategories$fin53, _newTagCategories$fin54;

        _result.push({
          title: "Stories | ".concat((_newTagCategories$fin51 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_STORIES */ .gT.tagCategory.TAG_CATEGORY_PREFAB_STORIES;
          })) === null || _newTagCategories$fin51 === void 0 ? void 0 : (_newTagCategories$fin52 = _newTagCategories$fin51.children[0]) === null || _newTagCategories$fin52 === void 0 ? void 0 : (_newTagCategories$fin53 = _newTagCategories$fin52.minValue) === null || _newTagCategories$fin53 === void 0 ? void 0 : (_newTagCategories$fin54 = _newTagCategories$fin53.toString()) === null || _newTagCategories$fin54 === void 0 ? void 0 : _newTagCategories$fin54.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin55 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_MODULE */ .gT.tagCategory.TAG_CATEGORY_PREFAB_MODULE;
      })) === null || _newTagCategories$fin55 === void 0 ? void 0 : (_newTagCategories$fin56 = _newTagCategories$fin55.children) === null || _newTagCategories$fin56 === void 0 ? void 0 : _newTagCategories$fin56.length) > 0) {
        var _newTagCategories$fin57, _newTagCategories$fin58, _newTagCategories$fin59, _newTagCategories$fin60;

        _result.push({
          title: "Modules | ".concat((_newTagCategories$fin57 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_MODULE */ .gT.tagCategory.TAG_CATEGORY_PREFAB_MODULE;
          })) === null || _newTagCategories$fin57 === void 0 ? void 0 : (_newTagCategories$fin58 = _newTagCategories$fin57.children[0]) === null || _newTagCategories$fin58 === void 0 ? void 0 : (_newTagCategories$fin59 = _newTagCategories$fin58.minValue) === null || _newTagCategories$fin59 === void 0 ? void 0 : (_newTagCategories$fin60 = _newTagCategories$fin59.toString()) === null || _newTagCategories$fin60 === void 0 ? void 0 : _newTagCategories$fin60.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin61 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
      })) === null || _newTagCategories$fin61 === void 0 ? void 0 : (_newTagCategories$fin62 = _newTagCategories$fin61.children) === null || _newTagCategories$fin62 === void 0 ? void 0 : _newTagCategories$fin62.length) > 0) {
        var _newTagCategories$fin63, _newTagCategories$fin64;

        _result.push({
          title: "From | ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatCurrency */ .xG)((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatNumber */ .uf)((_newTagCategories$fin63 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
          })) === null || _newTagCategories$fin63 === void 0 ? void 0 : (_newTagCategories$fin64 = _newTagCategories$fin63.children[0]) === null || _newTagCategories$fin64 === void 0 ? void 0 : _newTagCategories$fin64.minValue))),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin65 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      })) === null || _newTagCategories$fin65 === void 0 ? void 0 : (_newTagCategories$fin66 = _newTagCategories$fin65.children) === null || _newTagCategories$fin66 === void 0 ? void 0 : _newTagCategories$fin66.length) > 0) {
        var _newTagCategories$fin67, _newTagCategories$fin68;

        _result.push({
          title: "Min | ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatNumber */ .uf)((_newTagCategories$fin67 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
          })) === null || _newTagCategories$fin67 === void 0 ? void 0 : (_newTagCategories$fin68 = _newTagCategories$fin67.children[0]) === null || _newTagCategories$fin68 === void 0 ? void 0 : _newTagCategories$fin68.minValue), " sqft"),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin69 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING;
      })) === null || _newTagCategories$fin69 === void 0 ? void 0 : (_newTagCategories$fin70 = _newTagCategories$fin69.children) === null || _newTagCategories$fin70 === void 0 ? void 0 : _newTagCategories$fin70.length) > 0) {
        var _newTagCategories$fin71, _newTagCategories$fin72;

        _result.push({
          title: "Assembling | ".concat((_newTagCategories$fin71 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING;
          })) === null || _newTagCategories$fin71 === void 0 ? void 0 : (_newTagCategories$fin72 = _newTagCategories$fin71.children[0]) === null || _newTagCategories$fin72 === void 0 ? void 0 : _newTagCategories$fin72.name),
          isHeading: true,
          order: 66
        });
      }

      return _result;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY) {
      var _result3;

      // Call the function to get the concatenated result
      var _result2 = concatChildrenById(newTagCategories.filter(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING || i.title === "Website";
      })).map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          children: (0,lodash__WEBPACK_IMPORTED_MODULE_8__.uniqBy)(i.children, "id")
        });
      });

      _result2 = (_result3 = _result2) === null || _result3 === void 0 ? void 0 : _result3.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING;
      }).concat(_result2.filter(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */ .gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING;
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          title: null,
          name: null,
          filter_slug: null,
          icon: "Local:iconTagGeneral",
          children: item.children.map(function (itemChild) {
            return _objectSpread(_objectSpread({}, itemChild), {}, {
              name: "".concat(item.title, " | ").concat(itemChild.name),
              isHeading: true
            });
          }),
          isHeading: true,
          withoutClick: true,
          order: 66
        });
      }));
      return _result2;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL) {
      return newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ANIMAL_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_ANIMAL_CATEGORY;
      });
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO) {
      var _newTagCategories$fil3, _newTagCategories$fin73, _newTagCategories$fin74, _newTagCategories$fin75, _newTagCategories$fin76, _newTagCategories$fin77, _newTagCategories$fin78, _newTagCategories$fin79, _newTagCategories$fin80, _newTagCategories$fin81, _newTagCategories$fin82;

      var _result4 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION */ .gT.tagCategory.TAG_CATEGORY_ZOO_POPULATION;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQM */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQM;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
      });

      if (((_newTagCategories$fil3 = newTagCategories.filter(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQM */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQM || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION */ .gT.tagCategory.TAG_CATEGORY_ZOO_POPULATION || i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES;
      })) === null || _newTagCategories$fil3 === void 0 ? void 0 : _newTagCategories$fil3.length) > 0) {
        _result4.push({
          id: -1,
          pid: 1,
          level: 1,
          type: 0,
          description: null,
          icon: "Local:iconTagGeneral",
          order: 66,
          category: 9,
          createdAt: null,
          updatedAt: null,
          children: [],
          leafCount: 0,
          withoutClick: true,
          title: null
        });
      }

      _result4.push({
        title: "Animals | ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatTagRange */ .cN)(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES, (_newTagCategories$fin73 = newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES;
        })) === null || _newTagCategories$fin73 === void 0 ? void 0 : (_newTagCategories$fin74 = _newTagCategories$fin73.children[0]) === null || _newTagCategories$fin74 === void 0 ? void 0 : (_newTagCategories$fin75 = _newTagCategories$fin74.minValue) === null || _newTagCategories$fin75 === void 0 ? void 0 : (_newTagCategories$fin76 = _newTagCategories$fin75.toString()) === null || _newTagCategories$fin76 === void 0 ? void 0 : _newTagCategories$fin76.split(".")[0])),
        isHeading: true,
        order: 66
      });

      _result4.push({
        title: "Population | ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatTagRange */ .cN)(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION */ .gT.tagCategory.TAG_CATEGORY_ZOO_POPULATION, (_newTagCategories$fin77 = newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION */ .gT.tagCategory.TAG_CATEGORY_ZOO_POPULATION;
        })) === null || _newTagCategories$fin77 === void 0 ? void 0 : (_newTagCategories$fin78 = _newTagCategories$fin77.children[0]) === null || _newTagCategories$fin78 === void 0 ? void 0 : (_newTagCategories$fin79 = _newTagCategories$fin78.minValue) === null || _newTagCategories$fin79 === void 0 ? void 0 : (_newTagCategories$fin80 = _newTagCategories$fin79.toString()) === null || _newTagCategories$fin80 === void 0 ? void 0 : _newTagCategories$fin80.split(".")[0])),
        isHeading: true,
        order: 66
      });

      if (((_newTagCategories$fin81 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQM */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQM;
      })) === null || _newTagCategories$fin81 === void 0 ? void 0 : (_newTagCategories$fin82 = _newTagCategories$fin81.children) === null || _newTagCategories$fin82 === void 0 ? void 0 : _newTagCategories$fin82.length) > 0) {
        var _newTagCategories$fin83, _newTagCategories$fin84;

        _result4.push({
          title: "Size | ".concat((_newTagCategories$fin83 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQM */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQM;
          })) === null || _newTagCategories$fin83 === void 0 ? void 0 : (_newTagCategories$fin84 = _newTagCategories$fin83.children[0]) === null || _newTagCategories$fin84 === void 0 ? void 0 : _newTagCategories$fin84.name),
          isHeading: true,
          order: 66
        });
      }

      return _result4;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL) {
      var _newTagCategories$fin85, _newTagCategories$fin86;

      var _result5 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE */ .gT.tagCategory.TAG_CATEGORY_PARKFUL_SIZE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
      });

      _result5.push({
        id: -1,
        pid: 1,
        level: 1,
        type: 0,
        description: null,
        icon: "Local:iconTagGeneral",
        order: 66,
        category: 9,
        createdAt: null,
        updatedAt: null,
        children: [],
        leafCount: 0,
        withoutClick: true,
        title: null
      });

      if (((_newTagCategories$fin85 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE */ .gT.tagCategory.TAG_CATEGORY_PARKFUL_SIZE;
      })) === null || _newTagCategories$fin85 === void 0 ? void 0 : (_newTagCategories$fin86 = _newTagCategories$fin85.children) === null || _newTagCategories$fin86 === void 0 ? void 0 : _newTagCategories$fin86.length) > 0) {
        var _newTagCategories$fin87, _newTagCategories$fin88, _newTagCategories$fin89;

        _result5.push({
          title: "Size - ".concat((_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE */ .gT.tagCategory.TAG_CATEGORY_PARKFUL_SIZE, (_newTagCategories$fin87 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE */ .gT.tagCategory.TAG_CATEGORY_PARKFUL_SIZE;
          })) === null || _newTagCategories$fin87 === void 0 ? void 0 : (_newTagCategories$fin88 = _newTagCategories$fin87.children[0]) === null || _newTagCategories$fin88 === void 0 ? void 0 : (_newTagCategories$fin89 = _newTagCategories$fin88.name) === null || _newTagCategories$fin89 === void 0 ? void 0 : _newTagCategories$fin89.split(" - ")[0])),
          isHeading: true,
          order: 66
        });
      }

      return _result5;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO) {
      var _newTagCategories$fin90, _newTagCategories$fin91, _newTagCategories$fin92, _newTagCategories$fin93, _newTagCategories$fin94, _newTagCategories$fin95, _newTagCategories$fin96, _newTagCategories$fin97, _newTagCategories$fin98, _newTagCategories$fin99, _newTagCategories$fin100, _newTagCategories$fin101, _newTagCategories$fin102, _newTagCategories$fin103, _newTagCategories$fin104, _newTagCategories$fin105, _newTagCategories$fin106, _newTagCategories$fin111, _newTagCategories$fin112, _newTagCategories$fin117, _newTagCategories$fin118, _newTagCategories$fin121, _newTagCategories$fin122, _newTagCategories$fin125, _newTagCategories$fin126, _newTagCategories$fin129, _newTagCategories$fin130;

      var _result6 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES */ .gT.tagCategory.TAG_CATEGORY_CASINO_GAMES;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_POKER_TABLE */ .gT.tagCategory.TAG_CATEGORY_CASINO_POKER_TABLE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES_TABLE */ .gT.tagCategory.TAG_CATEGORY_CASINO_GAMES_TABLE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_MACHINES */ .gT.tagCategory.TAG_CATEGORY_CASINO_MACHINES;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_FEATURE */ .gT.tagCategory.TAG_CATEGORY_CASINO_FEATURE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ENTRY */ .gT.tagCategory.TAG_CATEGORY_ENTRY;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */ .gT.tagCategory.TAG_CATEGORY_DRESS_CODE;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7 */ .gT.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_PARKING */ .gT.tagCategory.TAG_CATEGORY_CASINO_PARKING;
      });

      _result6.push(_objectSpread(_objectSpread({}, newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES */ .gT.tagCategory.TAG_CATEGORY_CASINO_GAMES;
      })), {}, {
        children: (_newTagCategories$fin90 = newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES */ .gT.tagCategory.TAG_CATEGORY_CASINO_GAMES;
        })) === null || _newTagCategories$fin90 === void 0 ? void 0 : _newTagCategories$fin90.children.concat([{
          title: "".concat(((_newTagCategories$fin91 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_POKER_TABLE */ .gT.tagCategory.TAG_CATEGORY_CASINO_POKER_TABLE;
          })) === null || _newTagCategories$fin91 === void 0 ? void 0 : (_newTagCategories$fin92 = _newTagCategories$fin91.children[0]) === null || _newTagCategories$fin92 === void 0 ? void 0 : (_newTagCategories$fin93 = _newTagCategories$fin92.minValue) === null || _newTagCategories$fin93 === void 0 ? void 0 : (_newTagCategories$fin94 = _newTagCategories$fin93.toString()) === null || _newTagCategories$fin94 === void 0 ? void 0 : _newTagCategories$fin94.split(".")[0]) || "N/A", " | Poker Tables"),
          isHeading: true,
          order: 0,
          isCountInfo: true
        }, {
          title: "".concat(((_newTagCategories$fin95 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES_TABLE */ .gT.tagCategory.TAG_CATEGORY_CASINO_GAMES_TABLE;
          })) === null || _newTagCategories$fin95 === void 0 ? void 0 : (_newTagCategories$fin96 = _newTagCategories$fin95.children[0]) === null || _newTagCategories$fin96 === void 0 ? void 0 : (_newTagCategories$fin97 = _newTagCategories$fin96.minValue) === null || _newTagCategories$fin97 === void 0 ? void 0 : (_newTagCategories$fin98 = _newTagCategories$fin97.toString()) === null || _newTagCategories$fin98 === void 0 ? void 0 : _newTagCategories$fin98.split(".")[0]) || "N/A", " | Games Tables"),
          isHeading: true,
          order: 0,
          isCountInfo: true
        }, {
          title: "".concat(((_newTagCategories$fin99 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_MACHINES */ .gT.tagCategory.TAG_CATEGORY_CASINO_MACHINES;
          })) === null || _newTagCategories$fin99 === void 0 ? void 0 : (_newTagCategories$fin100 = _newTagCategories$fin99.children[0]) === null || _newTagCategories$fin100 === void 0 ? void 0 : (_newTagCategories$fin101 = _newTagCategories$fin100.minValue) === null || _newTagCategories$fin101 === void 0 ? void 0 : (_newTagCategories$fin102 = _newTagCategories$fin101.toString()) === null || _newTagCategories$fin102 === void 0 ? void 0 : _newTagCategories$fin102.split(".")[0]) || "N/A", " | Machines"),
          isHeading: true,
          order: 0,
          isCountInfo: true
        }])
      }));

      if (((_newTagCategories$fin103 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_FEATURE */ .gT.tagCategory.TAG_CATEGORY_CASINO_FEATURE;
      })) === null || _newTagCategories$fin103 === void 0 ? void 0 : (_newTagCategories$fin104 = _newTagCategories$fin103.children) === null || _newTagCategories$fin104 === void 0 ? void 0 : _newTagCategories$fin104.length) > 0) {
        _result6.push(_objectSpread({}, newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_FEATURE */ .gT.tagCategory.TAG_CATEGORY_CASINO_FEATURE;
        })));
      }

      _result6.push({
        id: -1,
        pid: 1,
        level: 1,
        type: 0,
        description: null,
        icon: "Local:iconTagGeneral",
        order: 66,
        category: 9,
        createdAt: null,
        updatedAt: null,
        children: [],
        leafCount: 0,
        withoutClick: true,
        title: null
      });

      if (((_newTagCategories$fin105 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
      })) === null || _newTagCategories$fin105 === void 0 ? void 0 : (_newTagCategories$fin106 = _newTagCategories$fin105.children) === null || _newTagCategories$fin106 === void 0 ? void 0 : _newTagCategories$fin106.length) > 0) {
        var _newTagCategories$fin107, _newTagCategories$fin108, _newTagCategories$fin109, _newTagCategories$fin110;

        _result6.push({
          title: "Size | ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_13__/* .formatTagRange */ .cN)(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT, (_newTagCategories$fin107 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */ .gT.tagCategory.TAG_CATEGORY_SIZE_SQFT;
          })) === null || _newTagCategories$fin107 === void 0 ? void 0 : (_newTagCategories$fin108 = _newTagCategories$fin107.children[0]) === null || _newTagCategories$fin108 === void 0 ? void 0 : (_newTagCategories$fin109 = _newTagCategories$fin108.minValue) === null || _newTagCategories$fin109 === void 0 ? void 0 : (_newTagCategories$fin110 = _newTagCategories$fin109.toString()) === null || _newTagCategories$fin110 === void 0 ? void 0 : _newTagCategories$fin110.split(".")[0])),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin111 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
      })) === null || _newTagCategories$fin111 === void 0 ? void 0 : (_newTagCategories$fin112 = _newTagCategories$fin111.children) === null || _newTagCategories$fin112 === void 0 ? void 0 : _newTagCategories$fin112.length) > 0) {
        var _newTagCategories$fin113, _newTagCategories$fin114, _newTagCategories$fin115, _newTagCategories$fin116;

        _result6.push({
          title: "Min Age | ".concat((_newTagCategories$fin113 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AGE */ .gT.tagCategory.TAG_CATEGORY_AGE;
          })) === null || _newTagCategories$fin113 === void 0 ? void 0 : (_newTagCategories$fin114 = _newTagCategories$fin113.children[0]) === null || _newTagCategories$fin114 === void 0 ? void 0 : (_newTagCategories$fin115 = _newTagCategories$fin114.minValue) === null || _newTagCategories$fin115 === void 0 ? void 0 : (_newTagCategories$fin116 = _newTagCategories$fin115.toString()) === null || _newTagCategories$fin116 === void 0 ? void 0 : _newTagCategories$fin116.split(".")[0]),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin117 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ENTRY */ .gT.tagCategory.TAG_CATEGORY_ENTRY;
      })) === null || _newTagCategories$fin117 === void 0 ? void 0 : (_newTagCategories$fin118 = _newTagCategories$fin117.children) === null || _newTagCategories$fin118 === void 0 ? void 0 : _newTagCategories$fin118.length) > 0) {
        var _newTagCategories$fin119, _newTagCategories$fin120;

        _result6.push({
          title: "Entry | ".concat((_newTagCategories$fin119 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ENTRY */ .gT.tagCategory.TAG_CATEGORY_ENTRY;
          })) === null || _newTagCategories$fin119 === void 0 ? void 0 : (_newTagCategories$fin120 = _newTagCategories$fin119.children[0]) === null || _newTagCategories$fin120 === void 0 ? void 0 : _newTagCategories$fin120.name),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin121 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */ .gT.tagCategory.TAG_CATEGORY_DRESS_CODE;
      })) === null || _newTagCategories$fin121 === void 0 ? void 0 : (_newTagCategories$fin122 = _newTagCategories$fin121.children) === null || _newTagCategories$fin122 === void 0 ? void 0 : _newTagCategories$fin122.length) > 0) {
        var _newTagCategories$fin123, _newTagCategories$fin124;

        _result6.push({
          title: "Dress Code | ".concat((_newTagCategories$fin123 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */ .gT.tagCategory.TAG_CATEGORY_DRESS_CODE;
          })) === null || _newTagCategories$fin123 === void 0 ? void 0 : (_newTagCategories$fin124 = _newTagCategories$fin123.children[0]) === null || _newTagCategories$fin124 === void 0 ? void 0 : _newTagCategories$fin124.name),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin125 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7 */ .gT.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7;
      })) === null || _newTagCategories$fin125 === void 0 ? void 0 : (_newTagCategories$fin126 = _newTagCategories$fin125.children) === null || _newTagCategories$fin126 === void 0 ? void 0 : _newTagCategories$fin126.length) > 0) {
        var _newTagCategories$fin127, _newTagCategories$fin128;

        _result6.push({
          title: "Open 24/7 | ".concat((_newTagCategories$fin127 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7 */ .gT.tagCategory.TAG_CATEGORY_CASINO_OPEN_24_7;
          })) === null || _newTagCategories$fin127 === void 0 ? void 0 : (_newTagCategories$fin128 = _newTagCategories$fin127.children[0]) === null || _newTagCategories$fin128 === void 0 ? void 0 : _newTagCategories$fin128.name),
          isHeading: true,
          order: 66
        });
      }

      if (((_newTagCategories$fin129 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_PARKING */ .gT.tagCategory.TAG_CATEGORY_CASINO_PARKING;
      })) === null || _newTagCategories$fin129 === void 0 ? void 0 : (_newTagCategories$fin130 = _newTagCategories$fin129.children) === null || _newTagCategories$fin130 === void 0 ? void 0 : _newTagCategories$fin130.length) > 0) {
        var _newTagCategories$fin131, _newTagCategories$fin132;

        _result6.push({
          title: "Parking | ".concat((_newTagCategories$fin131 = newTagCategories.find(function (i) {
            return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASINO_PARKING */ .gT.tagCategory.TAG_CATEGORY_CASINO_PARKING;
          })) === null || _newTagCategories$fin131 === void 0 ? void 0 : (_newTagCategories$fin132 = _newTagCategories$fin131.children[0]) === null || _newTagCategories$fin132 === void 0 ? void 0 : _newTagCategories$fin132.name),
          isHeading: true,
          order: 66
        });
      }

      if (props.item.founding) {
        _result6.push({
          title: "Founding year | ".concat(props.item.founding),
          isHeading: true,
          order: 66
        });
      }

      return _result6;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE) {
      var _result7 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_CASTLE_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_CASTLE_CATEGORY;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PRICE */ .gT.tagCategory.TAG_CATEGORY_PRICE;
      });

      return _result7;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT) {
      var _newTagCategories$fin133, _newTagCategories$fin134;

      var _result8 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_AREA */ .gT.tagCategory.TAG_CATEGORY_AREA;
      }).filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_STAR */ .gT.tagCategory.TAG_CATEGORY_STAR;
      });

      if (((_newTagCategories$fin133 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_STAR */ .gT.tagCategory.TAG_CATEGORY_STAR;
      })) === null || _newTagCategories$fin133 === void 0 ? void 0 : (_newTagCategories$fin134 = _newTagCategories$fin133.children) === null || _newTagCategories$fin134 === void 0 ? void 0 : _newTagCategories$fin134.length) > 0) {
        _result8.push(_objectSpread(_objectSpread({}, newTagCategories.find(function (i) {
          return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_STAR */ .gT.tagCategory.TAG_CATEGORY_STAR;
        })), {}, {
          order: -1
        }));
      }

      return _result8;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL) {
      var _result9 = newTagCategories.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_APARTHOTEL_CATEGORY;
      });

      return _result9;
    } else if (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
      var _newTagCategories$fin135, _newTagCategories$fin136;

      var _result10 = newTagCategories;

      if (((_newTagCategories$fin135 = newTagCategories.find(function (i) {
        return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_ENTRY */ .gT.tagCategory.TAG_CATEGORY_ENTRY;
      })) === null || _newTagCategories$fin135 === void 0 ? void 0 : (_newTagCategories$fin136 = _newTagCategories$fin135.children) === null || _newTagCategories$fin136 === void 0 ? void 0 : _newTagCategories$fin136.length) === undefined) {
        _result10.push({
          id: 1200,
          pid: 3,
          second_pid: null,
          level: 1,
          type: 0,
          title: "Entry",
          description: null,
          icon: "Local:iconTagEntry",
          order: 1,
          category: 6,
          filter_slug: "Entry",
          createdAt: null,
          updatedAt: null,
          name: "Entry",
          children: [{
            id: 1207,
            pid: 1200,
            second_pid: null,
            level: 2,
            type: 0,
            title: "N/A",
            description: null,
            icon: "",
            order: 0,
            category: 6,
            filter_slug: "N/A",
            createdAt: null,
            updatedAt: null,
            name: "N/A",
            leafCount: 1,
            isLeaf: true,
            minValue: null,
            maxValue: null,
            unit: null,
            label: null
          }],
          leafCount: 1
        });
      }

      return _result10;
    } else {
      return newTagCategories;
    }
  }; // Function to concatenate children by id


  function concatChildrenById(arr) {
    var result = [];
    var idMap = {};
    arr.forEach(function (item) {
      var id = item.id;

      if (!idMap[id]) {
        // Initialize a copy of the item with an empty children array
        var copy = _objectSpread({}, item);

        copy.children = [];
        result.push(copy);
        idMap[id] = copy;
      } // Concatenate the children


      idMap[id].children = idMap[id].children.concat(item.children);
    });
    return result;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17___default()), {
    style: [styles.container, props.style],
    children: [description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .ReadMoreText */ .XI, {
      text: description,
      style: styles.readMoreContainer,
      isMobileVersion: isMobileVersion
    }), menuItems.length > 0 && category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      className: isMobileVersion ? "px-4" : "",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CTabSelector */ .Qv, {
        items: menuItems,
        selectedIndex: selectedTabIndex,
        tabItemType: "round-tab",
        onSelectTab: function onSelectTab(item, index) {
          _onSelectTab(index);
        },
        containerStyle: {
          marginTop: 30,
          marginHorizontal: 16
        },
        isMobileVersion: isMobileVersion,
        isHeading: true,
        isUppercase: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)("div", {
      className: isMobileVersion ? "px-4" : "",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .TagIconSectionList */ .qM, {
        items: getTagCategories(),
        style: {
          marginTop: 30,
          paddingHorizontal: 16
        },
        onPressItem: onPressTagItem,
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .TagCategoryViewModal */ .U4, {
        item: detailTagCategory,
        isVisible: showTagCategoryModal,
        onClose: function onClose() {
          setShowTagCategoryModal(false);
        },
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17___default()), {
        style: styles.profileTagContainer,
        children: [((_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.event) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
          href: (0,_helpers__WEBPACK_IMPORTED_MODULE_11__/* .generateURLSlug */ .ZF)(props.item.id, props.item.title || props.item.displayName || props.item.nickname, props.item.startDate, category, "festivals"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(EventCardView, {
              item: props.item,
              style: {
                marginTop: isMobileVersion ? 8 : 15
              },
              onPress: null,
              isMobileVersion: isMobileVersion
            })
          })
        }), isShowLineupCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
          href: (0,_helpers__WEBPACK_IMPORTED_MODULE_11__/* .generateURLSlug */ .ZF)(props.item.id, props.item.title || props.item.displayName || props.item.nickname, props.item.startDate, category, "lineup"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(LineupCardView, {
              item: props.item,
              style: [{
                marginTop: isMobileVersion ? 8 : 15,
                height: 70,
                borderRadius: 25
              }, isMobileVersion ? {
                height: 50,
                borderRadius: 16
              } : {}],
              onPress: null,
              isMobileVersion: isMobileVersion
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(MediaCardView, {
          item: props.item,
          style: [{
            marginTop: isMobileVersion ? 8 : 15,
            height: 70,
            borderRadius: 25
          }, isMobileVersion ? {
            height: 50,
            borderRadius: 16
          } : {}],
          onPress: function onPress() {
            navigateToProfileBottomScreen(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileTabType.TAB_MEDIA */ .gT.profileTabType.TAB_MEDIA);
          },
          isMobileVersion: isMobileVersion
        }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(EditionCardView, {
          item: props.item,
          total: editionTotal,
          style: [{
            marginTop: isMobileVersion ? 8 : 15,
            height: 70,
            borderRadius: 25
          }, isMobileVersion ? {
            height: 50,
            borderRadius: 16
          } : {}],
          onPress: function onPress() {
            var _props$item5, _props$item6, _props$item7;

            navigation.push("".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_11__/* .generateURLSlug */ .ZF)(props === null || props === void 0 ? void 0 : (_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.id, props === null || props === void 0 ? void 0 : (_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : _props$item6.title, props === null || props === void 0 ? void 0 : (_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : _props$item7.startDate, category, "edition")));
          },
          isMobileVersion: isMobileVersion
        }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
          href: (0,_helpers__WEBPACK_IMPORTED_MODULE_11__/* .generateURLSlug */ .ZF)(props.item.id, props.item.title || props.item.displayName || props.item.nickname, props.item.startDate, category, "homes"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(SubListCardView, {
              title: "Homes",
              category: category,
              item: props.item,
              style: [{
                marginTop: isMobileVersion ? 8 : 15,
                height: 70,
                borderRadius: 25
              }, isMobileVersion ? {
                height: 50,
                borderRadius: 16
              } : {}],
              isMobileVersion: isMobileVersion
            })
          })
        }), isShowWall && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(WallCardView, {
          item: props.item,
          style: [{
            marginTop: isMobileVersion ? 8 : 15,
            height: 70,
            borderRadius: 25
          }, isMobileVersion ? {
            height: 50,
            borderRadius: 16
          } : {}],
          onPress: function onPress() {
            navigateToProfileBottomScreen(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileTabType.TAB_WALL */ .gT.profileTabType.TAB_WALL);
          },
          isMobileVersion: isMobileVersion
        }), ((_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.host) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(VenueCardView, {
          item: props.item,
          style: [{
            marginTop: isMobileVersion ? 8 : 15,
            height: 70,
            borderRadius: 25
          }, isMobileVersion ? {
            height: 50,
            borderRadius: 16
          } : {}],
          isMobileVersion: isMobileVersion
        }), isShowMemories && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(MemoryCardView, {
          item: props.item,
          style: [{
            marginTop: isMobileVersion ? 8 : 15,
            height: 70,
            borderRadius: 25
          }, isMobileVersion ? {
            height: 50,
            borderRadius: 16
          } : {}],
          onPress: function onPress() {
            navigateToProfileBottomScreen(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileTabType.TAB_MEMORIES */ .gT.profileTabType.TAB_MEMORIES);
          },
          isMobileVersion: isMobileVersion
        })]
      })]
    }), (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT) && lineupPoster && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17___default()), {
      style: {
        flex: 1,
        marginTop: isMobileVersion ? 20 : 50
      },
      children: [lineupPoster && isMobileVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        className: "unset-img",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          alt: "Lineup Poster ".concat(props === null || props === void 0 ? void 0 : (_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : _props$item9.title, " ").concat(moment__WEBPACK_IMPORTED_MODULE_7___default()(props === null || props === void 0 ? void 0 : (_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : _props$item10.startDate).format("YYYY")),
          src: lineupPoster,
          layout: "fill",
          className: "custom-img"
        })
      }), lineupPoster && !isMobileVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        className: "unset-img-600px",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          alt: "Lineup Poster ".concat(props === null || props === void 0 ? void 0 : (_props$item11 = props.item) === null || _props$item11 === void 0 ? void 0 : _props$item11.title, " ").concat(moment__WEBPACK_IMPORTED_MODULE_7___default()(props === null || props === void 0 ? void 0 : (_props$item12 = props.item) === null || _props$item12 === void 0 ? void 0 : _props$item12.startDate).format("YYYY")),
          src: lineupPoster,
          layout: "fill",
          className: "custom-img"
        })
      })]
    }),  false && /*#__PURE__*/0,  false && /*#__PURE__*/0, ( false) && /*#__PURE__*/0, isShowMapView && !isMobileVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      style: {
        marginTop: 30
      }
    }), isShowMapView ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(MapView, {
      category: category,
      address: _address,
      postcode: postcode,
      street: address,
      location: _location,
      venue: venue,
      city: city,
      mapLink: mapLink,
      country: nationality,
      accomodationUrl: accomodationUrl,
      transportUrl: transportUrl,
      style: {
        marginTop: 20,
        marginHorizontal: 16,
        borderRadius: isMobileVersion ? 0 : 20
      },
      isMobileVersion: isMobileVersion
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_17___default()), {
      style: {
        height: 30
      }
    }), isShowVenues && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .CardList */ .CS, {
      horizontal: false,
      items: props.item.venues,
      category: category,
      showInView: true // onItemAction={({ type, item }) => {
      //   if (type == Constants.actionType.ACTION_VIEW) {
      //     navigation.push({
      //       pathname: "/profile/details",
      //       query: {
      //         category: category,
      //         id: item.id,
      //       },
      //     });
      //   }
      // }}
      ,
      style: {
        marginTop: 16
      }
    }), isArtist && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(SpotifyListContainer, {
      spotifyId: spotifyId,
      isMobileVersion: isMobileVersion,
      style: {
        marginTop: isMobileVersion ? 30 : 50
      }
    }), !isMobileVersion && isShowMapView && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      style: {
        marginTop: 30
      }
    }), isShowNearByFestival && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(NearByFestivalView, {
      item: props.item,
      category: category,
      isMobileVersion: isMobileVersion
    }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(NearByOtherHomeView, {
      item: props.item,
      category: category,
      isMobileVersion: isMobileVersion
    }), isShowNearByVenue && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(NearByVenueView, {
      item: props.item,
      category: category,
      isMobileVersion: isMobileVersion
    }), category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      style: {
        marginTop: 18
      }
    }), category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST && category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL && category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(GuideProfile, {
      item: props.item,
      categoryType: category == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL : category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
      style: {
        marginTop: category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? 14 : 30
      }
    }), ( false) && /*#__PURE__*/0, ( false) && /*#__PURE__*/0, !isOfficial && !isPro && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(BottomInfoView, {
      helpText: getDeclaimText(category),
      style: {
        marginHorizontal: isMobileVersion ? 30 : 16
      },
      isMobileVersion: isMobileVersion,
      updatedAt: props.item.updatedAt
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_18___default().create({
  container: {
    alignSelf: "stretch",
    paddingBottom: 16,
    marginHorizontal: -16
  },
  readMoreContainer: {
    marginTop: 16,
    marginHorizontal: 24
  },
  profileTagContainer: {
    marginTop: 8
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  }
});
/* harmony default export */ __webpack_exports__["default"] = (ProfileAbout);

/***/ })

}]);